<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><a id="a0"></a><img alt="cover.jpg" height="675" src="images/cover.jpg" width="450"/><span class="t1">ℍ</span></p>
<p class="p0"><span class="t2">Come to the Water</span></p>
<p class="p0">By David Connor and E.F. Mulder</p>
<p class="p0"> </p>
<p class="p0">Published by <a href="http://www.jms-books.com" target="_blank"><span class="t2">JMS Books LLC</span></a></p>
<p class="p0">Visit <a href="http://www.jms-books.com" target="_blank"><span class="t2">jms-books.com</span></a> for more information.</p>
<p class="p0"> </p>
<p class="p0">Copyright 2023 David Connor and E.F. Mulder</p>
<p class="p0">ISBN 9781685505707</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001.vue?502ae17f